import { useState, useEffect } from 'react'

export const useIsMobile = (width) => {
  const [isMobile, setIsMobile] = useState(null)

  useEffect(() => {
    onResize()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const onResize = () => {
    const screen = width || 568

    if (window.innerWidth < screen) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  return { isMobile }
}
